import { HttpErrorResponse } from '@angular/common/http';
import swal from 'sweetalert2';

export class ErrorHelper {
	/** Show errors */
	public static showErrors(error: any): string {
		console.warn('ErrorHelper.showErrors is deprecated, please use showErrorSwal instead.'); //NOSONAR - This is a valid use
		// The error message
		let errorMessage = '';

		// The title of the swal
		let errorTitle = '';

		// Should be a HttpErrorResponse
		if (error instanceof HttpErrorResponse) {
			//errorTitle = error.statusText;

			if (error.error != null) {
				if (typeof error.error === 'string') {
					errorMessage = error.error;
				} else {
					if (error.error.title != null) {
						errorTitle = error.error.title;
					}
					if (Array.isArray(error.error.errors)) {
						errorMessage = error.error.errors.map((e: any) => e.message).join('<br/>'); // Error collections
					} else if (error.error.errors) {
						errorMessage = this.showObjectErrors(error.error.errors); // Object
					} else {
						errorMessage = 'No details available';
					}
				}
			}
		}

		// Show errors
		swal.fire({
			icon: 'error',
			title: errorTitle || 'Error',
			html: errorMessage,
			willOpen: () => {
				swal.hideLoading();
			},
		});
		return errorMessage;
	}

	/** Show error message when error is an opbject */
	private static showObjectErrors(errors: Object): string {
		let msg = [];
		Object.keys(errors).forEach(key => {
			if (Array.isArray(errors[key])) {
				// Modal validation errors, read the error property
				msg = msg.concat(errors[key]);
			} else {
				// Backend exception
				return JSON.stringify(errors);
			}
		});

		return msg.join('<br/>');
	}

	public static showWarnings(error: any): string {
		// The error message
		let warningMessage = '';

		// The title of the swal
		let warningTitle = '';

		// Should be a HttpErrorResponse

		if (error.errors != null) {
			if (typeof error.errors === 'string') {
				warningMessage = error.errors;
			} else {
				if (error.title != null) {
					warningTitle = error.title;
				}
				warningMessage = Array.isArray(error.errors)
					? error.errors.map((e: any) => e.message).join('<br/>') // Error collections
					: this.showObjectErrors(error.errors); // Object
			}
		}

		// Show errors
		swal.fire(warningTitle || 'Warning', warningMessage, 'warning');
		return warningMessage;
	}
}
